import { render, staticRenderFns } from "./posFlagIndex.vue?vue&type=template&id=64a0960b&"
import script from "./posFlagIndex.vue?vue&type=script&lang=js&"
export * from "./posFlagIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports